<template style="margin: 0px; padding: 0px;">
<div>
    <div class="test_two_box">
      <video class="video" id="myVideo"  type="video/mp4" autoplay loop muted>
        <source src="../assets/video.mp4" type="video/mp4" />
      </video>
      <div class="ste-type">
        <div class="bg-img">
          <div class="text ">德鑫医疗设备管理平台</div>
        </div>
        <div class="list">
            <div class="bg-list" v-for="(item,index) in list" :key='index'>
              <div class="item">
                <div class="it-name">{{item.name}}</div>
                <div class="it-text">{{item.text}}</div>
                <el-popover
                  v-if="index == 3"
                  placement="right"
                  width="130"
                  trigger="click">
                  <el-button-group  class="">
                     <div class="screen-name">德鑫互联</div>
                    <div class="screen">
                         <el-button type="primary" @click="leftIndex">左屏</el-button>
                          <el-button type="primary" @click="rightIndex">右屏</el-button>
                    </div>
                    <div class="screen-name">滴滴叫修</div>
                  <div class="screen ">
                       <el-button type="primary" @click="ddLeft">左屏</el-button>
                        <el-button type="primary" @click="ddRight">右屏</el-button>
                  </div>
                </el-button-group>

                  <!-- <el-button slot="reference">click 激活</el-button> -->
                  <div id="buttHover" class="it-a" slot="reference">{{item.into}}</div>
                </el-popover>
                <div v-else id="buttHover" class="it-a" @click="getInto(item.url,index)">{{item.into}}</div>
                <div class="iogin-top-animation" >
                	<div class="iogin-shooting_star">
                		<div class="shooting_star"></div>
                		<div class="shooting_star"></div>
                		<div class="shooting_star"></div>
                		<div class="shooting_star"></div>
                	</div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="bott">
        <div class="bott-text">
          <div> Copyright ? 2019 广东德鑫医疗科技有限公司 www.gddx333.com 版权所有
          </div>
          <div> 《中华人民共和国电信与信息服务业务经营许可证》编号：<a style="font-size: 12px;color: #364d76;" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备16060364号-2</a></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          // http://www.wx.gddx-v1.com:8084/#/
          list:[
            {
              name:'德鑫互联',
              text:'医疗设备全生命周期管理',
              into:'进入系统',
              url:'./fullLife'
            },
            {
              name:'滴滴叫修',
              text:'面向全球用户开放，医疗设备全生命 服务滴滴叫修、多方竞价、配件商城',
              into:'进入系统',
              url:'./transfer'
            },
            {
              name:'德鑫EPR',
              text:'全流程定制办公软件，提升办公效率',
              into:'进入系统',
              url:'http://www.erp.gddx-v1.com/'
            },
            {
              name:'数字化运营中心',
              text:'德鑫全平台系统数字化时代',
              into:'进入系统',
              url:''
            }
          ]
      }
    },
    created() {
      // 如果出现加载慢问题
      // 可以做个本地缓存 window.localStorage.setItem('键','值');
      // window.localStorage.getItem('取键');
    },
    methods:{
      getInto(url,index){

        if( index === 1 || index === 0){
          if(url){
              this.$router.push(url) //  跳转链接
            }
        }else{
          if(url){
              window.location.href = url
            }else{
              // alert('该系统正在升级,敬请期待！')
              this.open()
            }
        }

      },
      leftIndex(){
        this.$router.push('./left_index') //  跳转链接
      },
      rightIndex(){
        this.$router.push('./right_index') //  跳转链接
      },
      ddLeft(){
        this.$router.push('./dd_left') //  跳转链接
      },
      ddRight(){
        this.$router.push('./dd_right') //  跳转链接
      }
    }
  }
</script>

<style scoped>
.el-button-group{
  display: flex;
  justify-content: center;
}


  .ste-type{
    width: 100%;
    min-height: auto;
  }
  .bg-img{
    height: 95px;
    background-image: url(../assets/top-type.png);
     background-repeat:no-repeat;
    background-size: 1000px 95px;
    background-position: center;
    display: flex;
    justify-content: center;
}
  
  .text{
    font-size: 44px;
    text-align: center;
    letter-spacing:3px;
    font-weight: bold;
    color: #52FEFF;
    height: 95px;
    padding-top:10px;
  }
  .list{
    margin-top: 120px;
    justify-content: center;
    display: flex;
  }
  .bg-list{
    width: 318px;
    height: 353px;
    background-image: url(../assets/bgOption.png);
    background-repeat:no-repeat;
    background-size: 378px 353px;
    background-position: center;
  }
  .item{
    text-align: center;
    padding: 85px 43px  93px;
    height: 210px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
    overflow: hidden;
  }
  .it-name{
    font-size: 26px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #52FEFF;
  }
 .it-text{
   font-size: 14px;
   color: #6489E2 ;
 }
 .it-a{
    color: #1664FF;
    width: 180px;
    height: 42px;
    margin: 0 auto;
    line-height: 42px;
    border: 2px solid #1664FF;
    cursor:pointer;

    text-decoration: none;
 }
 #buttHover:hover{
   box-shadow: 0px 0px 6px 0px #8187a4;
   color: #699afd;
   border: 2px solid #699afd;
   width: 190px;

  transition: width 0.5s;
 }
 #buttHover{

   transition: width 0.5s;
 }
 video{
   position: fixed;
   bottom: 0;
   right: 0;
   /* min-height: 100%; */
   /* min-width: 800px; */
  width: 100%;
   height: 100%;
   object-fit: cover;
   z-index: -999999;
 }
 .bott{
   position: fixed;
   bottom: 0;
   left: 0;
   width: 100%;
 }
 .bott-text{
   display: flex;
   justify-content: center;
   align-items: center;
   color: #364d76;
   font-size: 12px;
   flex-direction: column
 }


 .iogin-top-animation {
 	position: absolute;
 	top: 0px;
 	left: 0px;
 	width: 90%;
 	height: 485px;
 	margin-left: 5%;
  z-index: -99;
 }
 /* 动画 */
 .iogin-shooting_star {
 	width: 100%;
 	height: 325px;
 	top: 0px;
 	left: 0px;
 	transform-origin: 50% 50%;
 	transform: rotate(125deg);
 	position: relative;
  overflow: hidden;
 }

 .shooting_star {
 	position: absolute;
 	left: 25%;
 	top: 75%;
 	height: 2px;
 	background: linear-gradient(-45deg, #148FFF, rgba(0, 0, 255, 0));
 	border-radius: 999px;
 	-webkit-filter: drop-shadow(0 0 6px #148FFF);
 	filter: drop-shadow(0 0 6px #148FFF);
 	-webkit-animation: tail 4000ms ease-in-out infinite, shooting 4000ms ease-in-out infinite;
 	animation: tail 4000ms ease-in-out infinite, shooting 4000ms ease-in-out infinite;
 }

 .shooting_star::before,
 .shooting_star::after {
 	content: '';
 	position: absolute;
 	top: calc(50% - 1.5px);
 	right: 0;
 	height: 3px;
 	background: linear-gradient(-45deg, rgba(0, 0, 255, 0), #148FFF, rgba(0, 0, 255, 0));
 	-webkit-transform: translateX(50%) rotateZ(45deg);
 	transform: translateX(50%) rotateZ(45deg);
 	border-radius: 100%;
 	-webkit-animation: shining 4000ms ease-in-out infinite;
 	animation: shining 4000ms ease-in-out infinite;
 }

 .shooting_star::after {
 	-webkit-transform: translateX(50%) rotateZ(-45deg);
 	transform: translateX(50%) rotateZ(-45deg);
 }

 .shooting_star:nth-child(1) {
 	top: calc(50% - 105px);
 	left: calc(25% - 30px);
 	-webkit-animation-delay: 1800ms;
 	animation-delay: 1800ms;
 }

 .shooting_star:nth-child(1)::before,
 .shooting_star:nth-child(1)::after,
 .shooting_star:nth-child(1)::after {
 	-webkit-animation-delay: 2000ms;
 	animation-delay: 2000ms;
 }

 .shooting_star:nth-child(2) {
 	top: calc(50% - 50px);
 	left: calc(50% - 179px);
 	-webkit-animation-delay: 1600ms;
 	animation-delay: 1600ms;
 }

 .shooting_star:nth-child(2)::before,
 .shooting_star:nth-child(2)::after,
 .shooting_star:nth-child(2)::after {
 	-webkit-animation-delay: 1800ms;
 	animation-delay: 1800ms;
 }

 .shooting_star:nth-child(3) {
 	top: calc(50% - -5px);
 	left: calc(50% - 120px);
 	-webkit-animation-delay: 2500ms;
 	animation-delay: 2500ms;
 }

 .shooting_star:nth-child(3)::before,
 .shooting_star:nth-child(3)::after,
 .shooting_star:nth-child(3)::after {
 	-webkit-animation-delay: 1800ms;
 	animation-delay: 1800ms;
 }

/* 左右屏入口样式 */
.screen-name{
  margin: 5px 0;
  font-size: 16px;
  font-weight: bold;
}
.screen{
 display: flex;
}
 @-webkit-keyframes tail {
   0% {
     width: 0;
   }
   30% {
     width: 20px;
   }
   100% {
     width: 0;
   }
 }

 @keyframes tail {
   0% {
     width: 0;
   }
   30% {
     width: 50px;
   }
   100% {
     width: 0;
   }
 }
 @-webkit-keyframes shining {
   0% {
     width: 0;
   }
   50% {
     width: 30px;
   }
   100% {
     width: 0;
   }
 }
 @keyframes shining {
   0% {
     width: 0;
   }
   50% {
     width: 20px;
   }
   100% {
     width: 0;
   }
 }
 @-webkit-keyframes shooting {
   0% {
     -webkit-transform: translateX(0);
             transform: translateX(0);
   }
   100% {
     -webkit-transform: translateX(100px);
             transform: translateX(100px);
   }
 }
 @keyframes shooting {
   0% {
     -webkit-transform: translateX(0);
             transform: translateX(0);
   }
   100% {
     -webkit-transform: translateX(200px);
             transform: translateX(200px);
   }
 }
 @-webkit-keyframes sky {
   0% {
     -webkit-transform: rotate(45deg);
             transform: rotate(45deg);
   }
   100% {
     -webkit-transform: rotate(405deg);
             transform: rotate(405deg);
   }
 }
 @keyframes sky {
   0% {
     -webkit-transform: rotate(45deg);
             transform: rotate(45deg);
   }
   100% {
     -webkit-transform: rotate(405deg);
             transform: rotate(405deg);
   }
 }
</style>
<style >
  .el-button-group{
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue